module.exports = __webpack_public_path__ + "static/media/hubspot.53f2d135.png";